import { Controller } from '@hotwired/stimulus';

/**
 * Dismisses a callout.
 *
 * Backs CalloutComponent's `dismissible:` variant: the component puts
 * `data-controller="callout"` on the callout root and wires its close button to
 * `callout#dismiss`, so the whole callout leaves the DOM on click.
 */
export default class extends Controller {
  /**
   * Removes the callout from the page.
   *
   * @returns {void}
   */
  dismiss () {
    this.element.remove();
  }
}
